module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "sign-up-illustration-teams@2x.0024c27a.png" + "?" + Date.now();